import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { Tabs } from '@base-ui/react/tabs';
import { cn } from '../../../utils/utils';
const VariantContext = createContext('underline');
export const TabsRoot = Tabs.Root;
const LIST = {
    underline: 'flex gap-3 shadow-[inset_0_-1px] pb-2 shadow-neutral-200',
    segmented: 'inline-flex gap-1 rounded-lg bg-neutral-200/70 p-1'
};
export const TabsList = ({ children, className, variant = 'underline', ...props }) => {
    return (_jsx(VariantContext.Provider, { value: variant, children: _jsx(Tabs.List, { ...props, className: cn('relative z-0', LIST[variant], className), children: children }) }));
};
const INDICATOR = {
    underline: 'top-[2.46rem] h-0.5 -translate-y-1/2 bg-primary-base',
    segmented: 'top-[var(--active-tab-top)] h-[var(--active-tab-height)] rounded-md bg-white shadow-sm'
};
export const TabsIndicator = ({ className, ...props }) => {
    const variant = useContext(VariantContext);
    return (_jsx(Tabs.Indicator, { ...props, className: cn('absolute left-0 z-[-1] w-[var(--active-tab-width)] translate-x-[var(--active-tab-left)] transition-all duration-200 ease-in-out', INDICATOR[variant], className) }));
};
const TAB = {
    underline: 'h-8 px-2 text-gray-600 before:inset-x-0 before:inset-y-1 hover:text-gray-900 data-[active]:text-primary-base',
    segmented: 'h-7 rounded-md px-3 font-roobert text-neutral-600 before:inset-0 before:rounded-md hover:text-neutral-900 data-[active]:text-neutral-900'
};
export const Tab = ({ children, className, ...props }) => {
    const variant = useContext(VariantContext);
    return (_jsx(Tabs.Tab, { ...props, className: cn('group relative flex items-center justify-center gap-2 border-0 text-sm font-medium outline-none transition-colors select-none before:absolute before:rounded-sm before:-outline-offset-1 before:outline-blue-800 focus-visible:before:outline-2', TAB[variant], className), children: children }));
};
export const TabPanel = ({ children, className, ...props }) => {
    return (_jsx(Tabs.Panel, { className: cn('relative -outline-offset-1 outline-blue-800 focus-visible:rounded-md focus-visible:outline-2', className), ...props, children: children }));
};
